import api from './client';

export interface OrgUser {
  id: string;
  fullName: string;
  email: string;
  role: 'owner' | 'admin' | 'member' | 'viewer';
  isActive: boolean;
  lastLogin?: string;
  createdAt: string;
}

export const listUsers = async (): Promise<OrgUser[]> => {
  const response = await api.get('/api/users');
  return response.data.users || [];
};

export const createUser = async (data: {
  email: string;
  fullName: string;
  role: string;
  password?: string;
}): Promise<{ user: OrgUser; temporaryPassword?: string }> => {
  const response = await api.post('/api/users', data);
  return response.data;
};

export const updateUser = async (
  id: string,
  data: { fullName?: string; role?: string; isActive?: boolean }
): Promise<OrgUser> => {
  const response = await api.patch(`/api/users/${id}`, data);
  return response.data.user;
};

export const deleteUser = async (id: string): Promise<void> => {
  await api.delete(`/api/users/${id}`);
};
